/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type OrganizationMemberSSOModeEnum = "OPTIONAL" | "REQUIRED" | "%future added value";
export type TeamMemberRole = "MAINTAINER" | "MEMBER" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type row_teamMember$ref: FragmentReference;
declare export opaque type row_teamMember$fragmentType: row_teamMember$ref;
export type row_teamMember = {|
  +id: string,
  +user: ?{|
    +name: string,
    +email: string,
    +avatar: {|
      +url: string
    |},
    +bot: boolean,
  |},
  +role: TeamMemberRole,
  +team: ?{|
    +organization: ?{|
      +slug: string
    |}
  |},
  +permissions: {|
    +teamMemberUpdate: ?{|
      +allowed: boolean
    |},
    +teamMemberDelete: ?{|
      +allowed: boolean
    |},
  |},
  +organizationMember: ?{|
    +uuid: string,
    +sso?: {|
      +mode: ?OrganizationMemberSSOModeEnum
    |},
    +security?: {|
      +twoFactorEnabled: boolean
    |},
  |},
  +$refType: row_teamMember$ref,
|};
export type row_teamMember$data = row_teamMember;
export type row_teamMember$key = {
  +$data?: row_teamMember$data,
  +$fragmentRefs: row_teamMember$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeSensitiveInfo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "row_teamMember",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Avatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bot",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMemberPermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "teamMemberUpdate",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "teamMemberDelete",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationMember",
      "kind": "LinkedField",
      "name": "organizationMember",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uuid",
          "storageKey": null
        },
        {
          "condition": "includeSensitiveInfo",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMemberSSO",
              "kind": "LinkedField",
              "name": "sso",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mode",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMemberSecurity",
              "kind": "LinkedField",
              "name": "security",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "twoFactorEnabled",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '88e30df468d20c2f1244ec20fbce97d5';

module.exports = node;
